import React from 'react';
import ReactDOM from 'react-dom/client';
import './shared/scss/index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import theme from './theme';
import { Provider } from 'react-redux';
import store from './store';

// Define a constant 'basename' with the string value 'BrokerPortal'.
const basename = 'BrokerPortal';

// Define a function 'endpoint' that takes a 'path' parameter and returns a modified path
// by appending the 'basename' constant at the beginning.
export function endpoint(path: string) {
	return `/${basename}${path}`;
}

// Create a React root instance to render your application.
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
// Render the application inside a 'React.StrictMode' component and use 'BrowserRouter' from 'react-router-dom'.
root.render(
	<React.StrictMode>
		<ThemeProvider theme={theme}>
			<BrowserRouter basename={basename}>
				{/* 
                    The 'Provider' component is used for Redux state management
                */}
				<Provider store={store}>
					{/* Render the 'App' component, which is the root of your application. */}
					<App />
				</Provider>
			</BrowserRouter>
		</ThemeProvider>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
